import React from 'react';
import PropTypes from 'prop-types';
import { DropdownMenuItem } from 'ui-components/components/dropdown-menu-item';
import { getLabelForGoodsType } from './label-for-goods-type';

import {
  LithiumMetalBatteriesContainedInEquipment,
  LithiumMetalBatteriesPackedWithEquipment,
  LithiumMetalBatteriesStandAlone,
  LithiumIonBatteriesContainedInEquipment,
  LithiumIonBatteriesPackedWithEquipment,
  LithiumIonBatteriesStandAlone,
  LimitedQuantitiesCanadaOnly,
} from '../../../../../../src/orders/other-shipping-options/constants/dhl-ecommerce/dangerous-goods-international';

const types = [
  LithiumMetalBatteriesContainedInEquipment,
  LithiumMetalBatteriesPackedWithEquipment,
  LithiumMetalBatteriesStandAlone,
  LithiumIonBatteriesContainedInEquipment,
  LithiumIonBatteriesPackedWithEquipment,
  LithiumIonBatteriesStandAlone,
  LimitedQuantitiesCanadaOnly,
];

export const GoodsTypeInternational = ({ onIntlChange }) => {
  return types.map((goodsType) => (
    <DropdownMenuItem key={goodsType} name={goodsType} onClick={onIntlChange}>
      {getLabelForGoodsType(goodsType)}
    </DropdownMenuItem>
  ));
};

GoodsTypeInternational.propTypes = {
  onIntlChange: PropTypes.func.isRequired,
};
